import {
    ApiParams,
    BaseClient,
    IActionResponse,
    IActionResult,
    IPagedResult,
} from "../../../assets/utils/lib";
import { Constants } from "../../../assets/utils/lib/constants";
import { SearchOrganizationDto } from "../../../components/community/resource/organization/organizationPage";
import { LookupDto, OrganizationLookupsDto } from "../../dto";
import { OrganizationDto } from "../../dto/communityResource/organizationDto";
import { OrganizationGridDto } from "../../dto/communityResource/organizationGridDto";

export class CommunityOrganizationClient extends BaseClient {
    routes = ["CommunityResource", "organization"];

    async getCommunityOrganizationAsync(
        id: string | undefined
    ): Promise<OrganizationDto> {
        const actions: string[] = ["GetOrganization"];
        const params: ApiParams[] = [new ApiParams("organizationId", id, true)];

        const result: OrganizationDto = await this.getAsync<OrganizationDto>(
            actions,
            params
        );
        return result;
    }

    async searchCommunityOrganizationsAsync(payload: SearchOrganizationDto | undefined): Promise<IPagedResult<OrganizationGridDto>> {
        const actions: string[] = ["SearchCommunityResourceOrganizations"];
        const result: IPagedResult<OrganizationGridDto> = await this.postAsync<
            SearchOrganizationDto,
            OrganizationGridDto,
            IPagedResult<OrganizationGridDto>
        >(actions, payload);
        return result;
    }

    async saveCommunityOrganizationAsync(
        payload: OrganizationDto | undefined
    ): Promise<IActionResult<OrganizationDto>> {
        const actions: string[] = ["SaveOrganization"];
        return await this.postAsync<OrganizationDto>(actions, payload);
    }

    async deActivateCommunityOrganizationAsync(
        id: string | undefined
    ): Promise<IActionResponse> {
        const actions: string[] = ["DeActivateOrganization"];
        const params: ApiParams[] = [new ApiParams("id", id, true)];

        return await this.getAsync(actions, params);
    }

    async deleteOrganizationAsync(
        id?: string | undefined
    ): Promise<IActionResponse> {
        const actions: string[] = ["DeleteOrganization"];
        const params: ApiParams[] = [new ApiParams("organizationId", id, true)];
        return await this.deleteAsync(actions, params);
    }

    async getLookupsAsync(communityId: string | undefined): Promise<OrganizationLookupsDto | undefined> {
        
        const actions: string[] = ["GetLookups"];
        if (communityId  === null || communityId === undefined || communityId === Constants.emptyString) {
            communityId = Constants.emptyGuid
        }

        const params: ApiParams[] = [
            new ApiParams("communityId", communityId, true),
        ];

        const result: { community: LookupDto[]; state: LookupDto[]; county: LookupDto[]; category: LookupDto[]; } = await this.getAsync<{ community: LookupDto[]; state: LookupDto[]; county: LookupDto[]; category: LookupDto[]; }>(actions, params);
        return result;
    }

    async getCommunityOrganizationsAsync(
        communityId: string
    ): Promise<OrganizationDto[]> {
        const actions: string[] = ["GetAllOrganizations"];
        const params: ApiParams[] = [
            new ApiParams("communityId", communityId, true),
        ];

        const result: OrganizationDto[] = await this.getAsync<OrganizationDto[]>(
            actions,
            params
        );
        return result;
    }
}
